module.exports = __webpack_public_path__ + "static/media/icon-next-white.14a35fe2.svg";